<template>
  <ubi-page-container class="Dashboard">
    <DialogCgv />
    <AutoOpenDialog :content1="true" :content2="true" :onConfirm="handleDialogConfirm" v-if="getUserRS.length > 0 && !getStopPopupStatistics"/>
    <el-main>
      <ubi-panel full-size>
        <el-carousel height="323px" v-if="universClient === 'IMMO'" :interval=5000>
          <el-carousel-item>
            <router-link :to="{ name: 'ProduitQualiforma' }" class="routerLink">
              <img :src="require(`@/assets/Slideshows-espace-client-formulaire-qualif-2.png`)" alt="Slide formulaire de qualification" class="slider-bv"/>
            </router-link>
          </el-carousel-item>
          <el-carousel-item v-if="isAncien">
            <a href="https://www.ubiflow.net/landing-page-campagne-mailing-diffusion-selective" target="_blank" rel=noopener>
              <img :src="require(`@/assets/diapos_immo/Slideshows-espace-client-diff-selective-immo.png`)" alt="Slide diffusion selective"/>
            </a>
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require(`@/assets/diapos_immo/Slideshows-espace-client-guide-rs.png`)" alt="Slide guide réseaux sociaux" />
          </el-carousel-item>
          <el-carousel-item>
            <a href="https://www.ubiflow.net/demo-gratuite-ubiflow?utm_source=espaceclient&utm_medium=siteweb&utm_campaign=espace-client&utm_content=slider-gafam-immo"
               target="_blank" rel=noopener>
              <!-- Gafam -->
              <img :src="require(`@/assets/diapos_immo/Slideshows-espace-client-gafam.png`)" alt="Slide Gafam"/>
            </a>
          </el-carousel-item>
          <el-carousel-item>
            <a href="https://www.ubiflow.net/demo-gratuite-ubiflow?utm_source=espaceclient&utm_medium=siteweb&utm_campaign=espace-client&utm_content=slider-contact-manager-immo"
               target="_blank" rel=noopener>
              <!-- ContactManager -->
              <img :src="require(`@/assets/diapos_immo/Slideshows-espace-client-permanents2.png`)" alt="Slide Contact manager"/>
            </a>
          </el-carousel-item>
        </el-carousel>
        <el-carousel height="323px" v-if="universClient === 'VO'" :interval=5000>
          <el-carousel-item>
            <router-link :to="{ name: 'ProduitQualiforma' }" class="routerLink">
              <img :src="require(`@/assets/Slideshows-espace-client-formulaire-qualif-2.png`)" alt="Slide formulaire de qualification" class="slider-bv"/>
            </router-link>
          </el-carousel-item>
          <el-carousel-item>
            <a href="https://www.ubiflow.net/landing-page-campagne-mailing-diffusion-selective" target="_blank" rel=noopener>
              <img :src="require(`@/assets/diapos_auto/Slideshows-espace-client-diff-selective-auto.png`)" alt="Slide diffusion selective"/>
            </a>
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require(`@/assets/diapos_auto/Slideshows-espace-client-guide-rs2.png`)" alt="Slide guide réseaux sociaux" />
          </el-carousel-item>
          <el-carousel-item>
            <a href="https://www.ubiflow.net/demo-gratuite-ubiflow?utm_source=espaceclient&utm_medium=siteweb&utm_campaign=espace-client&utm_content=slider-gafam-auto"
               target="_blank" rel=noopener>
              <!-- Gafam -->
              <img :src="require(`@/assets/diapos_auto/Slideshows-espace-client-gafam2.png`)" alt="Slide Gafam"/>
            </a>
          </el-carousel-item>
          <el-carousel-item>
            <a href="https://www.ubiflow.net/demo-gratuite-ubiflow?utm_source=espaceclient&utm_medium=siteweb&utm_campaign=espace-client&utm_content=slider-contact-manager-auto"
               target="_blank" rel=noopener>
              <!-- ContactManager -->
              <img :src="require(`@/assets/diapos_immo/Slideshows-espace-client-permanents2.png`)" alt="Slide Contact manager"/>
            </a>
          </el-carousel-item>
        </el-carousel>
      </ubi-panel>
      <el-row :gutter="20">
        <!--PARTIE DIFFUSION-->

          <template v-if="hasDiffusion">
            <el-col  :lg="16" >
              <ubi-panel size="sm" v-if="saisitAnnoncesEnLigne === true && saisitAnnoncesEnLigneEtFlux === false">
                  <template v-slot:left-column>
                     <div class="block" style="height: 345px;">
                       <div class="block-header">
                         <h3 v-if="isPromoteur">{{ $t("dashboard.myPrograms") }}</h3>
                         <h3 v-else>{{ $t("dashboard.myAds") }}</h3>
                      </div>
                       <div class="block-body">
                           <ubi-stat-value class="StatValueDashboard" style="text-align: center;"
                                           v-if="!isPromoteur && nbAnnoncesActives"
                                           :value="nbAnnoncesActives"
                                           :label="$t('dashboard.activeAds')"></ubi-stat-value>
                           <ubi-stat-value class="StatValueDashboard" style="text-align: center;"
                                           v-if="isPromoteur && nbAnnoncesActives"
                                           :value="nbAnnoncesActives"
                                           :label="$t('dashboard.activePrograms')"></ubi-stat-value>
                       </div>
                       <div class="block-footer">
                         <router-link :to="{ name: 'posts' }">
                           <el-link>{{ $t("dashboard.myAds_link") }}</el-link>
                         </router-link>
                       </div>
                     </div>
                  </template>
                  <template v-slot:right-column >
                    <div class="block" style="height: 345px;">
                      <div class="block-header">
                       <h3>{{ $t("dashboard.myDiffusions") }}</h3>
                       <p>{{ $t("dashboard.reportDate") }} {{ dateRapportDiffusion }}</p>
                      </div>
                    <div class="block-body">
                    <ubi-stat-value class="StatValueDashboard" style="text-align: center;" v-if="getStatisticsPourcentageAnnoncesDiffusees"
                                    :value="(getStatisticsPourcentageAnnoncesDiffusees) + '%'"
                                    :label="$t('dashboard.diffusionPercentageText')"></ubi-stat-value>
                    <ubi-stat-value class="StatValueDashboard" style="text-align: center;" v-else
                                    :value="0 + '%'"
                                    :label="$t('dashboard.diffusionPercentageText')"></ubi-stat-value>
                    </div>
                    <div class="block-footer">
                      <router-link :to="{ name: 'global-report' }">
                        <el-link
                            @click="eventAnalytics('rapport_diffusion')">{{ $t("dashboard.fullReportLink") }}</el-link>
                    </router-link>
                    </div>
                    </div>
                </template>
              </ubi-panel>
              <ubi-panel size="sm" v-else>
                <template v-slot:left-column>
                  <div class="block" style="height: 345px;" >
                    <div class="block-header">
                      <h3>{{ $t("dashboard.myIntegrations") }}</h3>
                      <p>{{ $t("dashboard.reportDate") }} {{ dateRapportIntegration }}</p>
                    </div>
                    <div class="block-body">
                        <ubi-stat-circle :value="nbAnnoncesAjoutees" :total="nbAnnoncesTraitees"
                                         :label="$t('dashboard.integrations')"></ubi-stat-circle>
                    </div>
                    <div class="block-footer">
                      <router-link :to="{ name: 'integration-global-report' }">
                        <el-link @click="eventAnalytics('rapport_integration')">
                          {{ $t("dashboard.fullReportLink") }}
                        </el-link>
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-slot:right-column>
                  <div class="block" style="height: 345px;">
                    <div class="block-header">
                      <h3>{{ $t("dashboard.myDiffusions") }}</h3>
                      <p>{{ $t("dashboard.reportDate") }} {{ dateRapportDiffusion }}</p>
                    </div>
                    <div class="block-body" v-loading="getLoadingPourcentageTotalDiffusion">
                      <ubi-stat-value icon="announcement" v-if="getStatisticsPourcentageAnnoncesDiffusees != null" :value="getStatisticsPourcentageAnnoncesDiffusees + '%'" :label="$t('portals.report.globalAdsDiffused')" />
                    </div>
                    <div class="block-footer">
                      <router-link :to="{ name: 'global-report' }">
                        <el-link @click="eventAnalytics('rapport_diffusion')">{{ $t("dashboard.fullReportLink") }}</el-link>
                      </router-link>
                    </div>
                  </div>
                </template>
              </ubi-panel>
            </el-col>
          </template>
          <template v-else>
            <ubi-panel>
              <template>
                <CardProduct :image="require('@/assets/produits/Illustration-MD-2024.png')" :title="$t('layouts.diffusion')" :subtitle="$t('dashboard.titleProduitNonActive')" :content="$t('dashboard.txtProduitNonActiveDiffusion')" />
              </template>
            </ubi-panel>
          </template>

        <!-- Bloc "Mes dernières annonces -->
        <el-col :lg="8">
          <el-last-ads :posts="posts"></el-last-ads>
        </el-col>
      </el-row>

      <div v-if="!isUSH|| (isUSH && getSitimmoUser.typeCompte === 'Customer')">
        <ubi-panel icon="agenda" title="Contact Manager" v-if="possedeContactManager === true">
          <!--<el-button slot="header-actions" size="mini" type="danger">Télécharger l'export excel</el-button>-->
          <p>
            {{ $t("dashboard.cmYouReceived") }}
            <strong>{{ $t("dashboard.cmContactsWithCount", {count: nbContacts}) }}</strong>
            {{ $t("dashboard.cmLast7Days") }}
          </p>
          <template v-slot:left-column>
            <div class="block">
              <div class="block-header">
                <h4>{{ $t("dashboard.cmPortals") }}</h4>
              </div>
              <div class="block-body">
                <el-table :data="contactsStats">
                  <el-table-column :label="$t('dashboard.cmColumnTitle')">
                    <template v-slot="{ row: portal }">
                      <ubi-icon name="direction" class="text-primary pr-2"/>
                      <strong class="font-secondary">{{ portal[1].nom }}</strong>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('dashboard.cmColumnContacts')" align="right" width="80">
                    <template v-slot="{ row: portal }">{{ portal[1].nb_contacts }}</template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="block-footer">
                <router-link :to="{ name: 'contacts-portals' }">
                  <el-link @click="eventAnalytics('cm_rapport_complet_portails')">{{
                      $t("dashboard.fullReportLink")
                    }}
                  </el-link>
                </router-link>
              </div>
            </div>
          </template>
          <template v-slot:right-column>
            <div class="block">
              <div class="block-header">
                <h4>{{ $t("dashboard.cmAds") }}</h4>
              </div>
              <div class="block-body">
                <el-table :data="contactsPosts">
                  <el-table-column :label="$t('dashboard.cmColumnTitle')">
                    <template v-slot="{ row: post }">
                      <ubi-icon name="direction" class="text-primary pr-2"/>
                      {{ post.reference }} - {{ post.titre }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('dashboard.cmColumnContacts')" align="right" width="80">
                    <template v-slot="{ row: post }">{{ post.nbContactsMailtracking }}</template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="block-footer">
                <router-link :to="{ name: 'contacts-posts' }">
                  <el-link @click="eventAnalytics('cm_rapport_complet_annonces')">{{
                      $t("dashboard.fullReportLink")
                    }}
                  </el-link>
                </router-link>
              </div>
            </div>
          </template>
        </ubi-panel>

        <template v-if="possedeContactManager !== true">
          <ubi-panel>
            <template>
              <CardProduct :image="require('@/assets/produits/Illustration-CM-2024.png')" :title="$t('layouts.contactManager')" :subtitle="$t('dashboard.titleProduitNonActive')" :content="$t('dashboard.txtProduitNonActiveCM')" />
            </template>
          </ubi-panel>
        </template>

<!--        SocialManager-->
        <CardDashboardSM></CardDashboardSM>
      </div>
    </el-main>
  </ubi-page-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Carousel, CarouselItem } from 'element-ui'
import moment from 'moment'

import { putStopPopupSfc } from '@/services/users'
import { getPosts } from '@/services/posts'
import { getPortals } from '@/services/portals'
import { getAnnoncesContacts, getContactsAnnoncesEnTete } from '@/services/contacts'
import { getDataReportES, getEnteteDashboardES, getRapportIntegrationGlobalES } from '@/services/reports'
import MyLastAds from './posts/components/MyLastAds'
import i18next from 'i18next'
import UbiPageContainer from '@/components/PageContainer'
import AutoOpenDialog from '@/components/ui/AutoOpenDialog.vue'
import UbiStatValue from '@/components/statistics/StatValue.vue'
import UbiPanel from '@/components/Panel.vue'
import UbiStatCircle from '@/components/statistics/StatCircle.vue'
import CardProduct from '@/components/ui/CardProduct.vue'
import UbiIcon from '@/components/Icon.vue'
import DialogCgv from '@/components/DialogCgv.vue'
import CardDashboardSM from '@/components/ui/CardDashboardSM.vue'

export default {
  name: 'Dashboard',
  components: {
    CardDashboardSM,
    DialogCgv,
    CardProduct,
    UbiIcon,
    UbiStatCircle,
    UbiStatValue,
    UbiPanel,
    AutoOpenDialog,
    UbiPageContainer,
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem,
    ElLastAds: MyLastAds
  },
  inject: ['browserContext'],
  metaInfo () {
    return {
      title: this.$t('dashboard.metaTitle')
    }
  },
  data () {
    return {
      message: '',
      posts: [],
      entete: null,
      contactsPosts: [],
      contactsPortals: [],
      nbAnnonces: 0,
      nbContacts: 0,
      filtersReports: {
        offset: 0,
        limit: 1,
        search: null
      },
      rapportIntegration: null,
      rapportDiffusion: null,
      nbAnnoncesIntegrees: 0,
      nbAnnoncesAjoutees: 0,
      nbAnnoncesTraitees: 0,
      dateRapportIntegration: null,
      nbAnnoncesDiffusees: 0,
      nbAnnoncesRapportDiffusion: 0,
      dateRapportDiffusion: null,
      nbAnnoncesActives: null,
      pourcentageAnnoncesDiffusees: 0,
      dialogSubscribeInstagram: null,
      popupMaintenance: false,
      popupConnexionFacebook: false,
      nbBV: 0,
      contactsStats: null,
      dialogContactEcVisible: false,
      today: {},
      dateDebutMaintenance: new Date('May 20, 2024 00:00:00'),
      dateFinMaintenance: new Date('May 31, 2024 00:00:00'),
      refsFilter: null,
      infosContactsAnnonces: null
    }
  },
  async beforeMount () {
    this.today = new Date().getTime()
    if (!this.getUser.popupMaintenanceClose && (this.today >= this.dateDebutMaintenance) && (this.today <= this.dateFinMaintenance)) {
      this.popupMaintenance = true
    }
    const self = this
    const promises = []
    if (this.isPromoteur === false) {
      promises.push(getPosts({ offset: 0, limit: 3, orderBy: '-DC', annoncesActivees: true }))
    } else {
      promises.push(getPosts({
        offset: 0,
        limit: 3,
        orderBy: '-DC',
        annoncesActivees: true,
        typeObjets: '3000'
      }))
    }
    promises.push(getPortals({
      fields: 'diffuseurNom,nbContactsMailtracking',
      offset: 0,
      limit: 4,
      sort: 'annonces'
    }))

    promises.push(getContactsAnnoncesEnTete({ before: moment().subtract(7, 'days').format('YYYY-MM-DD') }))
    promises.push(getEnteteDashboardES())
    promises.push(
      getRapportIntegrationGlobalES(null)
        .then(async function (results) {
          self.rapportIntegration = results
          if (self.rapportIntegration.type === 'error') {
            return false
          }
          if (Object.values(self.rapportIntegration.infos.hits).length > 0) {
            const rapport = Object.values(self.rapportIntegration.infos.hits)[0]
            self.rapportId = rapport.id
            if (rapport.nbAnnoncesOperation && rapport.nbAnnoncesTotal && rapport.endDate) {
              self.nbAnnoncesTraitees = rapport.nbAnnoncesTotal
              self.nbAnnoncesAjoutees = rapport.nbAnnoncesOperation
              self.dateRapportIntegration = self.convertDateMysql(rapport.endDate)
            } else {
              const callDataRapport = await getDataReportES(self.rapportId)
              if (callDataRapport.type === 'error') {
                return false
              }
              const dataRapport = Object.values(callDataRapport.infos.hits)
              if (dataRapport) {
                self.nbAnnoncesTraitees = dataRapport[0].bilanAnnonces.traites ? dataRapport[0].bilanAnnonces.traites : 0
                self.nbAnnoncesAjoutees = dataRapport[0].bilanAnnonces.integrees ? dataRapport[0].bilanAnnonces.integrees : 0
                self.dateRapportIntegration = self.convertDateMysql(dataRapport[0].endDate)
              }
            }
          }
        }, self)
    )

    promises.push(getPosts({
      etat: 'V'
    }).then(async function (results) {
      self.nbBV = results.total
    }, self)
    )

    await Promise.all(promises)
      .then(async function (results) {
        // getPosts
        self.posts = results[0].list
        self.nbAnnoncesActives = results[0].total

        // // getAnnoncesContacts
        // if (results[1] && results[1].infos._embedded && results[1].infos._embedded.annonce) {
        //   self.contactsPosts = results[1].infos._embedded.annonce
        // }

        // getPortals
        self.contactsPortals = results[1].list

        // getContactsAnnoncesEnTete
        self.nbContacts = results[2].infos.nbContactsGeneres
        self.nbAnnonces = results[2].infos.nbAnnonces
        self.infosContactsAnnonces = results[2].infos.infosAnnonces
        self.contactsStats = []

        for (const i in results[2].infos.infosPortails) {
          self.contactsStats.push([i, results[2].infos.infosPortails[i]])
        }
        // getEnteteES
        const callEntete = results[3]
        if (callEntete.type === 'error') {
          return false
        }

        if (callEntete.infos.hits && callEntete.infos.hits.DIFFUSION) {
          self.entete = callEntete.infos.hits
          self.nbAnnoncesDiffusees = self.entete.DIFFUSION.difusees
          self.nbAnnoncesRapportDiffusion = self.entete.DIFFUSION.traites
          self.pourcentageAnnoncesDiffusees = Math.floor(((self.entete.DIFFUSION.traites - self.entete.DIFFUSION.non_valides) / (self.entete.DIFFUSION.traites)) * 100)
          // Cas rare où traité + supprimes + non_valides > total
          if (self.pourcentageAnnoncesDiffusees > 100) {
            self.pourcentageAnnoncesDiffusees = 100
          }
          self.dateRapportDiffusion = self.convertDateMysql(self.entete.endDate)
        } else {
          self.entete = null
          self.nbAnnoncesDiffusees = 0
          self.nbAnnoncesRapportDiffusion = 0
          self.nbAnnoncesTraitees = 0
          self.nbAnnoncesAjoutees = 0
          self.pourcentageAnnoncesDiffusees = 0
          self.dateRapportDiffusion = null
          self.dateRapportIntegration = null
        }
      }, self)

    if (this.hasContactManager) {
      if (this.infosContactsAnnonces) {
        const contactsPostsCall = await getAnnoncesContacts({ offset: 0, limit: 4, refs: this.triReferences(this.infosContactsAnnonces) })
        this.contactsPosts = contactsPostsCall.infos._embedded.annonce
        this.contactsPosts.forEach(element => self.findNbContacts(element))
      }
    }
  },
  computed: {
    ...mapGetters('productLine', ['hasDiffusion', 'hasLocalSeo', 'hasContactManager']),
    ...mapGetters(['getUniverse', 'getJob']),
    ...mapGetters(['getSitimmoUser', 'getUser', 'getUserRS', 'getProduits', 'getPopupSfcVue', 'getStopPopupStatistics', 'getCodeReseauSfc', 'getIdExterneSfc', 'isUserDemo']),
    ...mapGetters('globalDiffusionReport', ['getLoadingPourcentageTotalDiffusion']),
    ...mapGetters('KPI', [
      'getKpi',
      'getLoadingKPI'
    ]),
    isAncien () {
      return this.getSitimmoUser.metier === 'AGENCE'
    },
    isPromoteur () {
      return this.getSitimmoUser.metier === 'PROMOTEUR'
    },
    universClient () {
      return this.getSitimmoUser.univers
    },
    possedeContactManager () {
      return this.hasContactManager
    },
    saisitAnnoncesEnLigne () {
      return this.getSitimmoUser.saisit_annonces_en_ligne
    },
    saisitAnnoncesEnLigneEtFlux () {
      return this.getSitimmoUser.saisit_en_ligne_et_flux
    },
    isUSH () {
      return this.getUser.isUSH
    },
    afficherPopupSFC: {
      get () {
        if (this.getProduits != null) {
          if (this.hasLocalSeo && !this.getUser.stopPopupSfc && !this.getPopupSfcVue) {
            this.getPopupDemarrageSFC = true
          }
          return this.getPopupDemarrageSFC
        }
        return null
      },
      set () {
        this.closePopupDemarrageSFC()
      }
    },
    lang () {
      return i18next.language
    },
    getStatisticsPourcentageAnnoncesDiffusees () {
      return this.$store.getters['globalDiffusionReport/getPourcentageTotalDiffusion']
    }
  },
  methods: {
    ...mapActions('notifications', ['addNotification']),
    eventAnalytics (category) {
      this.$ga.event('dashboard', 'clic', category, this.getSitimmoUser.id)
    },
    triReferences (referencesObj) {
      // Convertir l'objet en tableau de tuples [reference, valeur]
      const referencesTuples = Object.entries(referencesObj)

      // Extraire toutes les valeurs
      const valeurs = Object.values(referencesObj)

      // Vérifier si toutes les valeurs sont égales
      const toutesEgales = valeurs.every(valeur => valeur === valeurs[0])

      let resultatArray
      if (toutesEgales) {
        // Sélectionner les 4 premières références
        resultatArray = referencesTuples.slice(0, 4).map(([reference, _]) => reference)
      } else {
        // Trier par valeur décroissante
        resultatArray = referencesTuples
          .sort(([_, valeurA], [__, valeurB]) => valeurB - valeurA)
          .slice(0, 4) // Ajout de la limite à 4 références
          .map(([reference, _]) => reference)
      }
      // Formater en chaîne de caractères avec virgules : ref1, ref2, ref3
      return resultatArray.join(',')
    },
    convertDateMysql (date) {
      return moment(date).format('DD/MM/YYYY - HH:mm')
    },
    findNbContacts (annonce) {
      for (const [key, value] of Object.entries(this.infosContactsAnnonces)) {
        if (key === annonce.reference) {
          annonce.nbContactsMailtracking = value
        }
      }
      if (annonce.nbContactsMailtracking === null) {
        annonce.nbContactsMailtracking = 0
      }
      return annonce
    },
    async closePopupDemarrageSFC () {
      this.loading = true
      if (this.getUser.stopPopupSfc) {
        const rep = await putStopPopupSfc(this.getUser)
        if (rep.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
        }
        this.$store.commit('setPopupSfcVue', true)
      }
      this.getPopupDemarrageSFC = false
      this.$store.commit('setPopupSfcVue', true)
      this.loading = false
    },
    handleDialogConfirm () {
      this.$router.push('/socialNetworks')
    }
  },
  mounted () {
    this.dialogContactEcVisible = true
    this.$store.dispatch('globalDiffusionReport/loadEnteteStatistics', null, { root: true })
    this.$store.dispatch('globalDiffusionReport/loadPourcentageTotalDiffusion')
    this.$store.dispatch('statisticsDBKS/loadStatsDBKS')
    this.$store.dispatch('KPI/loadKPI')
  }
}

</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.el-loading-spinner {
  top: 10% !important;
}

.el-carousel__item img.slider-bv {
  max-width: 100%;
  max-height: 100%;
  object-fit: fill;
}

.el-carousel__item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1020px) {
  .el-carousel__item img {
    object-fit: contain;
  }

  .el-carousel__item img.slider-bv {
    object-fit: fill;
  }
}

@media screen and (max-width: 641px) {
  .el-carousel__item img.slider-bv {
    max-width: 100%;
    max-height: 60%;
    transform: translateY(30%);
  }
}

.Dashboard {
  &-post {
    @extend .py-2, .px-3;
  }

  &-post-title {
    @extend .font-secondary, .font-weight-bold, .mb-0;
  }

  &-post-date {
    font-size: $font-size-sm;
  }

  &-post-tag {
    @extend .px-2, .font-weight-bolder;
    color: $black;
    background: $yellow;
    font-size: $font-size-xs;
    position: absolute;
    right: map-get($spacers, 2);
    text-transform: uppercase;
    top: map-get($spacers, 2);
  }
}

.linkRefAnnonceDashboard {
  text-decoration: none;
  color: white;
}

.linkRefAnnonceDashboard:hover {
  color: white;
  text-decoration-color: white;
}

@media (max-width: 640px) {
  .carouselDasboard {
    width: 100%;
    max-height: 150px;
    overflow: hidden;
  }
  .carouselImageDasboard {
    margin-top: auto;
    margin-bottom: auto;
    display: block;
    height: auto;
    width: 100%;
  }
}

.StatValueDashboard .StatValue {
  @extend .font-secondary;
  display: inline-flex;
  font-size: 60px;
  text-align: left;
  flex-direction: row;

  &-icon {
    @extend .text-primary, .mr-3;
  }

  &-content {
    display: flex;
    flex-direction: column;
  }

  &-value {
    @extend .text-primary, .font-weight-bold;
    font-size: 60px;
    line-height: $font-size-lg-alt * 0.9;
  }

  &-subValue {
    @extend .font-weight-bold;
    line-height: $font-size-base-alt;
  }

  &-label {
    display: block;
    font-size: $font-size-sm-alt;
    text-transform: uppercase;
  }

  .el-divider {
    background: $black;
    height: 11px;
    vertical-align: baseline;
  }
}
.blue-style{
  color: rgb(0,168,182);
}
.blue-style-email{
  color: rgb(0,168,182);
  text-decoration: underline;
}

// Changements
.block {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .block-header {
    padding-top: 0;
    text-align: left;
    flex-shrink: 0;
  }
  .block-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    &-title{
      color: #00a4bd;
      text-transform: lowercase;
      font-family: "Dosis", Helvetica, Arial, sans-serif;
      text-align: left;
      &:first-letter{
        text-transform: capitalize;
      }
    }
    &-stats {
      display: flex;
      justify-content: space-between;
      ul{
        text-align: left;
        list-style-type: none;
      }
    }
    &-values {
      list-style-type: none;
      color: #00a4bd;
      font-weight: bold;
    }

    &-rs{
      width: 100%;
    }
  }
  .block-footer {
    padding: 16px 16px 0 16px;
    text-align: left;
    flex-shrink: 0;
  }
}
</style>
